import React from "react";
import close from "../../../assets/images/icons/close.svg";
import Layout from "../../Layout/Layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Adress } from "./Adress";
import ContactDetail from "./ContactDetail";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  getPersonalInfo,
  updateProfile,
} from "../../../Redux/Actions/user/userAll";
import axios from "axios";
import { checkAllFieldsFilled } from "../../../utils/static";
import { toastSuccess } from "../../../Redux/Reducers/user/ConsultationSlice";

export default function PersonalInformation() {
  const userInfo = useSelector((state) => state?.consultaions?.userInfo);
  const dispatch = useDispatch();
  const [userData, setUserData] = useState();
  const [viewVal, setViewVal] = useState(true);
  var today = new Date().toISOString().split("T")[0];

  const { from } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo) {
      setUserData(userInfo);
    }
  }, [userInfo]);

  useEffect(() => {
    dispatch(getPersonalInfo());
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  // const handleUpdate = () => {
  //   dispatch(updateProfile({ personalInfo: userData })).then((res) => {
  //     const personalInfoObject = res.payload.user.data;
  //     const checkList = {
  //       phnNumber: "",
  //       age: "",
  //       address: "",
  //     };
  //     checkList.phnNumber = personalInfoObject?.phnNumber
  //       ? personalInfoObject?.phnNumber == null
  //         ? false
  //         : true
  //       : false;
  //     checkList.age = personalInfoObject?.age
  //       ? personalInfoObject?.age == null
  //         ? false
  //         : true
  //       : false;

  //     const checkAdd = (obj) => {
  //       var count = 0;
  //       for (let key in obj) {
  //         if (key != "secondLine") {
  //           if (obj[key] == "") {
  //             count = count + 1;
  //           }
  //         }
  //       }
  //       return count >= 1 ? false : true;
  //     };

  //     checkList.address =
  //       Object.keys(personalInfoObject.address).length < 4
  //         ? false
  //         : checkAdd(personalInfoObject.address);

  //     if (checkList.phnNumber && checkList.age && checkList.address) {
  //       if (from == "fromnewcons") {
  //         navigate("/new-consultation");
  //       }
  //     }
  //   });
  // };

  const handleClose = () => {
    setViewVal(false);
  };

  // ============================================================================================

  // const handleUpdate = () => {
  //   dispatch(updateProfile({ personalInfo: userData })).then((res) => {
  //     const personalInfoObject = res.payload.user.data;

  //     const checkList = {
  //       phnNumber: false,
  //       age: false,
  //       address: false,
  //     };

  //     checkList.phnNumber = personalInfoObject?.phnNumber
  //       ? personalInfoObject?.phnNumber !== null
  //       : false;
  //     checkList.age = personalInfoObject?.age
  //       ? personalInfoObject?.age !== null
  //       : false;

  //     const checkAdd = (obj) => {
  //       let count = 0;
  //       for (let key in obj) {
  //         if (key !== "secondLine") {
  //           if (obj[key] === "") {
  //             count++;
  //           }
  //         }
  //       }
  //       return count === 0;
  //     };

  //     checkList.address =
  //       Object.keys(personalInfoObject.address).length < 4
  //         ? false
  //         : checkAdd(personalInfoObject.address);

  //     if (checkList.phnNumber && checkList.age && checkList.address) {
  //       if (from === "fromnewcons") {
  //         navigate("/new-consultation");
  //       }

  //       if (checkAllFieldsFilled(personalInfoObject)) {
  //         const payload = {
  //           chamber_token: "knhUYvR40FpgcI5S2xlX",
  //           first_name: personalInfoObject.firstName,
  //           last_name: personalInfoObject.lastName,
  //           dob: personalInfoObject.age,
  //           gender: "male",
  //           address_line_1: personalInfoObject.address.houseNo + " " + personalInfoObject.address.street,
  //           city: personalInfoObject.address.townCity,
  //           country: "UK",
  //           post_code: personalInfoObject.address.postCode,
  //           phone: personalInfoObject.phnNumber,
  //           patient_email: personalInfoObject.email,
  //           chamber_patient_id: personalInfoObject.firstName,
  //           country_code: 44,
  //         };

  //         axios
  //           .post(
  //             "https://thingproxy.freeboard.io/fetch/https://clynxx.uk/index.php/apiv2/addPatient",
  //             payload
  //           )
  //           .then((response) => {
  //             console.log("API Success:", response?.data);
  //             const patient_id = response?.data?.data?.patient_id
  //             const chamber_patient_id = response?.data?.data?.chamber_patient_id 

  //             dispatch(updateProfile({ 
  //                 personalInfo: { patient_id, chamber_patient_id } 
  //             }));
  //           })
  //           .catch((error) => {
  //             console.error("API Error:", error);
  //           });
  //       } else {
  //         alert("Please fill all the required fields before submitting.");
  //       }
  //     }
  //   });
  // };

  // const handleUpdate = (updatedFields) => {
  //   const updatedUserData = { ...userData, ...updatedFields };
  //   dispatch(updateProfile({ personalInfo: updatedUserData })).then((res) => {
  //     const personalInfoObject = res.payload.user.data;

  //     const checkList = {
  //       phnNumber: personalInfoObject?.phnNumber !== null,
  //       age: personalInfoObject?.age !== null,
  //       address: Object.keys(personalInfoObject?.address || {}).length >= 4,
  //     };

  //     toastSuccess(res?.payload?.user?.message);
  //     if (checkList.phnNumber && checkList.age && checkList.address) {
  //       if (from === "fromnewcons") {
  //         navigate("/new-consultation");
  //       }

  //       if (checkAllFieldsFilled(personalInfoObject)) {
  //         const payload = {
  //           chamber_token: "knhUYvR40FpgcI5S2xlX",
  //           first_name: personalInfoObject.firstName,
  //           last_name: personalInfoObject.lastName,
  //           dob: personalInfoObject.age,
  //           gender: personalInfoObject.gender,
  //           address_line_1: personalInfoObject.address.houseNo + " " + personalInfoObject.address.street,
  //           city: personalInfoObject.address.townCity,
  //           country: "UK",
  //           post_code: personalInfoObject.address.postCode,
  //           phone: personalInfoObject.phnNumber,
  //           patient_email: personalInfoObject.email,
  //           chamber_patient_id: personalInfoObject.firstName,
  //           country_code: 44,
  //         };

  //         axios.post(
  //           `${process.env.REACT_APP_HOST_NAME}api/clynxx/addPatient`,
  //           payload
  //         )
  //           .then((response) => {
  //             console.log("API Success:", response.data);
  //             dispatch(updateProfile({
  //               personalInfo: {
  //                 patient_id: response?.data?.data?.patient_id,
  //                 chamber_patient_id: response?.data?.data?.chamber_patient_id
  //               }
  //             }));
  //           })
  //           .catch((error) => {
  //             console.error("API Error:", error);
  //           });
  //       } else {
  //         console.log("Please fill all the required fields before submitting.");
  //       }
  //     }
  //   });
  // };

  // const handleUpdate = async (updatedFields) => {
  //   try {

  //     const updatedUserData = { ...userData, ...updatedFields };
  //     const res = await dispatch(updateProfile({ personalInfo: updatedUserData }));
  //     const personalInfoObject = res.payload.user.data;
  
  //     const checkList = {
  //       phnNumber: personalInfoObject?.phnNumber !== null,
  //       age: personalInfoObject?.age !== null,
  //       address: Object.keys(personalInfoObject?.address || {}).length >= 4,
  //     };
  
  //     toastSuccess(res?.payload?.user?.message);

  //     if (checkList.phnNumber && checkList.age && checkList.address) {
  //       if (from === "fromnewcons") {
  //         navigate("/new-consultation");
  //       }
  
  //       if (checkAllFieldsFilled(personalInfoObject)) {
  //         const payload = {
  //           chamber_token: "knhUYvR40FpgcI5S2xlX",
  //           first_name: personalInfoObject.firstName,
  //           last_name: personalInfoObject.lastName,
  //           dob: personalInfoObject.age,
  //           gender: personalInfoObject.gender,
  //           address_line_1: `${personalInfoObject.address.houseNo} ${personalInfoObject.address.street}`,
  //           city: personalInfoObject.address.townCity,
  //           country: "UK",
  //           post_code: personalInfoObject.address.postCode,
  //           phone: personalInfoObject.phnNumber,
  //           patient_email: personalInfoObject.email,
  //           chamber_patient_id: personalInfoObject.firstName,
  //           country_code: 44,
  //         };
  
  //         const response = await axios.post(
  //           `${process.env.REACT_APP_HOST_NAME}api/clynxx/addPatient`,
  //           payload
  //         );
  //         console.log("API Success:", response.data);
  
  //         await dispatch(updateProfile({
  //           personalInfo: {
  //             patient_id: response?.data?.data?.patient_id,
  //             chamber_patient_id: response?.data?.data?.chamber_patient_id
  //           }
  //         }));
  
  //         return {
  //           success: true,
  //           data: response.data
  //         };
  //       } else {
  //         console.log("Please fill all the required fields before submitting.");
  //         return {
  //           success: false,
  //           message: "Missing required fields"
  //         };
  //       }
  //     }
  
  //     return {
  //       success: true,
  //       message: "Profile updated but no API call made due to validation"
  //     };
  
  //   } catch (error) {
  //     console.error("Error in handleUpdate:", error);
  //     return {
  //       success: false,
  //       error: error.message
  //     };
  //   }
  // };

  const handleUpdate = async (updatedFields) => {
    try {
      const updatedUserData = { ...userData, ...updatedFields };
  
      // Update profile and handle potential errors
      let res;
      try {
        res = await dispatch(updateProfile({ personalInfo: updatedUserData }));
      } catch (dispatchError) {
        console.error("Error in dispatch(updateProfile):", dispatchError);
        return {
          success: false,
          error: "Failed to update profile",
          details: dispatchError.message,
        };
      }
  
      const personalInfoObject = res.payload.user.data;
  
      const checkList = {
        phnNumber: personalInfoObject?.phnNumber !== null,
        age: personalInfoObject?.age !== null,
        address: Object.keys(personalInfoObject?.address || {}).length >= 4,
      };
  
      toastSuccess(res?.payload?.user?.message);
  
      if (checkList.phnNumber && checkList.age && checkList.address) {
        if (from === "fromnewcons") {
          navigate("/new-consultation");
        }
  
        if (checkAllFieldsFilled(personalInfoObject)) {
          const payload = {
            chamber_token: "knhUYvR40FpgcI5S2xlX",
            first_name: personalInfoObject.firstName,
            last_name: personalInfoObject.lastName,
            dob: personalInfoObject.age,
            gender: personalInfoObject.gender,
            address_line_1: `${personalInfoObject.address.houseNo} ${personalInfoObject.address.street}`,
            city: personalInfoObject.address.townCity,
            country: "UK",
            post_code: personalInfoObject.address.postCode,
            phone: personalInfoObject.phnNumber,
            patient_email: personalInfoObject.email,
            chamber_patient_id: personalInfoObject.firstName,
            country_code: 44,
          };
  
          let response;
          try {
            response = await axios.post(
              `${process.env.REACT_APP_HOST_NAME}api/clynxx/addPatient`,
              payload
            );
            console.log("API Success:", response.data);
          } catch (apiError) {
            console.error("API Error:", apiError);
            return {
              success: false,
              error: "Failed to call addPatient API",
              details: apiError.message,
            };
          }
  
          try {
            await dispatch(updateProfile({
              personalInfo: {
                patient_id: response.data.data.data.patient_id,
                chamber_patient_id: response?.data?.data?.data?.chamber_patient_id
              },
            }));
          } catch (dispatchError) {
            console.error("Error in dispatch(updateProfile):", dispatchError);
            return {
              success: false,
              error: "Failed to update profile with API response",
              details: dispatchError.message,
            };
          }
  
          return {
            success: true,
            data: response.data,
          };
        } else {
          console.log("Please fill all the required fields before submitting.");
          return {
            success: false,
            message: "Missing required fields",
          };
        }
      }
  
      return {
        success: true,
        message: "Profile updated but no API call made due to validation",
      };
    } catch (error) {
      console.error("Error in handleUpdate:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  };
  
  // const handleUpdatePersonalData = () => {

  //   dispatch(updateProfile({ personalInfo: userData })).then((res) => {
  //     const personalInfoObject = res.payload.user.data;

  //     const checkList = {
  //       phnNumber: personalInfoObject?.phnNumber !== null,
  //       age: personalInfoObject?.age !== null,
  //       address: Object.keys(personalInfoObject?.address || {}).length >= 4,
  //     };

  //     toastSuccess(res?.payload?.user?.message);
  //     if (checkList.phnNumber && checkList.age && checkList.address) {
  //       if (from === "fromnewcons") {
  //         navigate("/new-consultation");
  //       }

  //       if (checkAllFieldsFilled(personalInfoObject)) {
  //         const payload = {
  //           chamber_token: "knhUYvR40FpgcI5S2xlX",
  //           first_name: personalInfoObject.firstName,
  //           last_name: personalInfoObject.lastName,
  //           dob: personalInfoObject.age,
  //           gender: personalInfoObject.gender,
  //           address_line_1: personalInfoObject.address.houseNo + " " + personalInfoObject.address.street,
  //           city: personalInfoObject.address.townCity,
  //           country: "UK",
  //           post_code: personalInfoObject.address.postCode,
  //           phone: personalInfoObject.phnNumber,
  //           patient_email: personalInfoObject.email,
  //           chamber_patient_id: personalInfoObject.firstName,
  //           country_code: 44,
  //         };

  //            axios.post(`${process.env.REACT_APP_HOST_NAME}api/clynxx/addPatient`, payload)
  //           .then((response) => {
  //             console.log("API Success:", response.data);

  //             dispatch(updateProfile({
  //               personalInfo: {
  //                 patient_id: response.data.data.data.patient_id,
  //                 chamber_patient_id: response?.data?.data?.data?.chamber_patient_id
  //               }
  //             }));
  //           })
  //           .catch((error) => {
  //             console.error("API Error:", error);
  //           });
  //       } else {
  //         console.log("Error")
  //       }
  //     }
  //   });
  // };


  const handleUpdatePersonalData = async () => {
    try {
      const res = await dispatch(updateProfile({ personalInfo: userData  }));
      const personalInfoObject = res.payload.user.data;
  
      const checkList = {
        phnNumber: personalInfoObject?.phnNumber !== null,
        age: personalInfoObject?.age !== null,
        address: Object.keys(personalInfoObject?.address || {}).length >= 4,
      };
  
      toastSuccess(res?.payload?.user?.message);
  
      if (checkList.phnNumber && checkList.age && checkList.address) {
        if (from === "fromnewcons") {
          navigate("/new-consultation");
        }
  
        if (checkAllFieldsFilled(personalInfoObject)) {
          const payload = {
            chamber_token: "knhUYvR40FpgcI5S2xlX",
            first_name: personalInfoObject.firstName,
            last_name: personalInfoObject.lastName,
            dob: personalInfoObject.age,
            gender: personalInfoObject.gender,
            address_line_1: personalInfoObject.address.houseNo + " " + personalInfoObject.address.street,
            city: personalInfoObject.address.townCity,
            country: "UK",
            post_code: personalInfoObject.address.postCode,
            phone: personalInfoObject.phnNumber,
            patient_email: personalInfoObject.email,
            chamber_patient_id: personalInfoObject.firstName,
            country_code: 44,
          };
  
          try {
            const response = await axios.post(`${process.env.REACT_APP_HOST_NAME}api/clynxx/addPatient`, payload);
            console.log("API Success:", response.data);
  
            dispatch(updateProfile({
              personalInfo: {
                patient_id: response.data.data.data.patient_id,
                chamber_patient_id: response?.data?.data?.data?.chamber_patient_id
              }
            }));
          } catch (error) {
            console.error("API Error:", error);
          }
        } else {
          console.log("Error: Not all fields are filled");
        }
      }
    } catch (error) {
      console.error("Error in handleUpdatePersonalData:", error);
    }
  };
  

  const handleGenderClick = (gender) => {
    setUserData((prev) => ({ ...prev, gender }));
  };

  console.log(userData, "userData", userInfo)


  return (
    <Layout>
      <div className="col-lg-10">
        <div className="desc_area pb-0">
          <div className="row">
            <div className="col-lg-12">
              <div className="back-button mb-4">
                <Link to="/my-account/sidebar" className="white-btn">
                  Back
                </Link>
              </div>
            </div>
          </div>

          {from == "fromnewcons" && (
            <Modal
              show={viewVal}
              onHide={handleClose}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              className="admin-popup provisional-popup detailed_popup"
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="table-responsive table-defaut-design text_inner">
                  {/* <h4> Personal Info required</h4> */}
                  Please provide following details
                </div>
              </Modal.Body>

              <Modal.Footer>
                <div className="d-flex flex-column">
                  <div className="btn_submit mb-3">
                    <button
                      onClick={handleClose}
                      className="btn btn-primary btn-custom btn-lg w-100 submit_btn confirmation_btn "
                    >
                      Okay
                    </button>
                  </div>
                </div>
              </Modal.Footer>
            </Modal>
          )}

          <div className="row">
            <div className="col-xl-7 col-lg-7 col-md-9 col-12">
              <div className="new_consultation_booking common_shadow personal_info_page">
                <h2 className="common_title padding_36">
                  Personal Information
                </h2>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="personal_details medical_history_details">
                      <div id="accordion" className="accordian_collapse">
                        <div className="card mb-2">
                          <div
                            className="card-header accordian_head"
                            id="headingOne"
                          >
                            <h5 className="mb-0">
                              <div
                                className=" d-flex personal_inner_sec dropdown_arrow collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                                type="button"
                              >
                                <h6 className="mb-0">General</h6>
                              </div>
                            </h5>
                          </div>
                          <div
                            id="collapseOne"
                            className="collapse"
                            aria-labelledby="headingOne"
                            data-parent="#accordion"
                          >
                            <div className="card-body inner_padding personal_info_inner">
                              <div className="d-flex justify-content-between align-items-center mb-3 peronal-content-detail">
                                <h6 className="mb-0">First Name</h6>
                                <div className="options_part questions_options">
                                  <ul className="mb-0 d-flex p-0 questions_options_inner">
                                    <li>
                                      <input
                                        className="select_option_btn width_200 box_shadow"
                                        onChange={handleChange}
                                        value={userData?.firstName}
                                        name="firstName"
                                      />
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mb-3 peronal-content-detail">
                                <h6 className="mb-0">Second Name</h6>
                                <div className="options_part questions_options">
                                  <ul className="mb-0 d-flex p-0 questions_options_inner">
                                    <li>
                                      <input
                                        className="select_option_btn width_200 box_shadow"
                                        onChange={handleChange}
                                        value={userData?.lastName}
                                        name="lastName"
                                      />
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center mb-3 peronal-content-detail">
                                <h6 className="mb-0">Date of Birth</h6>
                                <div className="options_part questions_options">
                                  <ul className="mb-0 d-flex p-0 questions_options_inner">
                                    <li>
                                      <input
                                        className="select_option_btn width_200 box_shadow date_width"
                                        onChange={handleChange}
                                        value={userData?.age}
                                        max={today}
                                        type="date"
                                        name="age"
                                      />
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center mb-3 peronal-content-detail ">
                                <h6 className="mb-0">Gender</h6>
                                <div className="options_part questions_options">
                                  <ul className="mb-0 d-flex p-0 questions_options_inner justify-content-between gap-2">
                                    <li>
                                      <a
                                        onClick={() => handleGenderClick("male")}
                                        className={
                                          userData?.gender == "male"
                                            ? "colorcc w-75 cursor-pointer"
                                            : "select_option_btn w-75 box_shadow cursor-pointer"
                                        }
                                      >
                                        Male
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        onClick={() => handleGenderClick("female")}
                                        className={
                                          userData?.gender == "female"
                                            ? "colorcc w-75 cursor-pointer"
                                            : "select_option_btn w-75 box_shadow cursor-pointer"
                                        }
                                      >
                                        Female
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              <div className="add-more-btn mt-4">
                                <button
                                  onClick={handleUpdatePersonalData}
                                  className="d-flex justify-content-center dark_btn"
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <Adress userData={userData} handleUpdate={handleUpdate} />
                        <ContactDetail userData={userData} handleUpdate={handleUpdate} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </Layout>
  );
}
